import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does an AI solution cost?",
    answer: `<p>AI software development require a time and monetary investment – and so you can expect to account for your business requirements, technology stack, frameworks, team size, hiring arrangement and job location when estimating the budget for your AI solution. At TekRevol, because we want to support startups and entrepreneurs who want to pursue growth with AI, we do offer diverse hiring arrangements with different cash flow settings and pay-as-you-go models.</p>`,
  },
  {
    question: "How to use data for AI solutions?",
    answer: `<p>At TekRevol, we have a holistic method of utilizing data in our AI application development services. These steps include data collection and preprocessing, data annotation and feature engineering and lastly data cleaning and splitting.</p>`,
  },
  {
    question: "When should businesses use AI?",
    answer: ` <p>AI has had transformative impacts on business ROI in diverse sectors. So if you are in a business where you want to improve productivity, performance and efficiency, automate simple to complex tasks, personalize customer experiences, provide decision support, and analyze complex data to understand business forecasts, then AI is your deal.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>AI Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
